<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Regimen de Retención">
          <b-form>
            <app-retencion-tipo
              label="Tipo de Retención"
              :nombre= 'retencionTipoNombre'
              :lista= 'retencionesTiposList'
              :labelCols= 'labelCols'
              :valido="retencionTipoValida"
              :msjInvalido="retencionTipoInvalidaMsj"
              @updated="retencionTipoActualizada">
            </app-retencion-tipo>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Inactivo"
              label-for="inactivo"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import RetencionTipo from '../shared/abmSelect.vue';
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'retencionregimen/getField',
  mutationType: 'retencionregimen/updateField',
});

export default {
  name: 'RetencionRegimen',
  components: {
    appABMButton: ABMButtons,
    appRetencionTipo: RetencionTipo,
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      retencionTipoValida: null,
      retencionTipoInvalidaMsj: '',

      labelCols: 2,

      retencionesTipos: [],
      retencionesTiposList: [],
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'retencionTipo',
      'retencionTipoNombre',
      'inactivo',
    ])
  },  
  created() {
    let retencionRegimenId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        retencionRegimenId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('retencionregimen/inicializar', retencionRegimenId)
      .then(() => this.getDatosAdicionales())
      .catch(error => {
        this.modalOkAction = null;
        this.modalHiddenAction = null;
        this.modalMensaje = "Se produjo un error al recuperar la información del regimen de retención."
        this.modalMsj = true;
      })
      .finally(() => this.hideSpinner())
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('retencionestipos/getList')
        .then(() => {
            vm.retencionesTipos = this.$store.getters['retencionestipos/list']
            vm.retencionesTiposList = this.$store.getters['retencionestipos/selectList']
          })
          .catch(error => {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = "Se produjo un error al recuperar la información de tipos de retención.";
            this.modalMsj = true;
          })
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres.';
          }
          if (this.$v.nombre.$error && !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del regimen de retención';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let retencionTipo = null;
      if (this.retencionTipoNombre) {
        retencionTipo = this.getSelected(this.retencionesTipos, this.retencionTipoNombre);
      }
      this.$store.dispatch('retencionregimen/setRetencionTipo', retencionTipo);

      let retencionTipoError = true;
      if (this.retencionTipo) {
        if (this.retencionTipo.id) {
          if (this.retencionTipo.id != 0) {
            retencionTipoError = false;
          }
        }
      }
      if (retencionTipoError) {
        save = false;
        this.retencionTipoValida = false;
        this.retencionTipoInvalidaMsj = "Debe seleccionar el tipo de retención correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('retencionregimen/save')
            .then(() => {
              this.modalOkAction = this.goList;
              this.modalHiddenAction = this.goList;
              this.modalMensaje = "Los cambios se registraron con éxito.";
              this.modalMsj = true;
            })
            .catch( error => {
              this.procesando = false;
              this.modalOkAction = null;
              this.modalHiddenAction = null;
              this.modalMensaje = error;
              this.modalMsj = true;
            })
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "RetencionesRegimenes" });
    },
    retencionTipoActualizada(retencionTipoNombre) {
      this.retencionTipoNombre = retencionTipoNombre;
      this.retencionTipoValida = null;
      this.retencionTipoInvalidaMsj = '';
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
